import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/awarenessReflection.css";
import useTranslation from "../hooks/useTranslation";

function AwarenessReflection({ updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleContinue = () => {
    updateProgress('awareness-reflection');
    navigate('/dilema-instructions');
  };

  return (
    <div className="reflection-container">
      {/* Contenido central */}
      <div className="reflection-content">
        <div className="reflection-header">
          <h1 className="game-titleR">{t('awarenessReflection.gameTitle')}</h1>
          <h2 className="game-subtitleR">{t('awarenessReflection.gameSubtitle')}</h2>
        </div>

        <div className="instructions-box">
          <h2 className="instructions-title">{t('awarenessReflection.title')}</h2>
          <h3 className="instructions-subtitle">{t('awarenessReflection.subtitle')}</h3>
          
          <div className="instructions-text">
            <p>
              {t('awarenessReflection.paragraph1')}
            </p>
            
            <p>
              {t('awarenessReflection.paragraph2')}
            </p>
            
            <p>
              {t('awarenessReflection.paragraph3')}
            </p>
            
            <p>
              {t('awarenessReflection.paragraph4')}
            </p>
            
            <p>
              {t('awarenessReflection.paragraph5')}
            </p>
            <p>
              {t('awarenessReflection.paragraph6')}
            </p>
          </div>

          <button className="continue-button" onClick={handleContinue}>
            {t('awarenessReflection.continueButton')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AwarenessReflection;

